export default __webpack_public_path__ + "navigation-examples-route-deserialize-1200-bdb51af7712a7e017672dffed9bd34aa.webp";